import React, {useEffect, useState} from "react";
import { Router } from "react-router-dom";
import { I18nProvider } from "./i18n";
import { ThemeProvider } from "styled-components";
import { theme } from "./theme";
import { AuthProvider } from "././contexts/auth/auth.provider";
import { AppProvider } from "./contexts/app/app.provider";
import { SearchProvider } from "./contexts/search/search.provider";
import { HeaderProvider } from "./contexts/header/header.provider";

import AppLayout from "./containers/LayoutContainer/AppLayout";
import { useDeviceType } from "./helper/useDeviceType";
import { CartProvider } from "./contexts/cart/use-cart";
import { FavoritesProvider } from "./contexts/favorites/use-favorites";
import { StoreLogoProvider } from "./contexts/store-logo/use-storeLogo";

// External CSS import here
import "rc-drawer/assets/index.css";
import "rc-table/assets/index.css";
import "rc-collapse/assets/index.css";
import "react-multi-carousel/lib/styles.css";
// import 'components/MultiCarousel/MultiCarousel.style.css';
import "@redq/reuse-modal/lib/index.css";
import { GlobalStyle } from "./styled/global.style";
import history from "./services/history";
import configureStore from "./store/ConfigureStore";
import { Provider } from "react-redux";
import Routes from "./routes";
//Notification
import { GetToken, onMessageListener } from "./firebase"
import NotificationToast from "./components/Notification/NotificationToast";
import { useMaintenanceMode } from "./components/MaintenanceMode/MaintenanceModeProvider";
import { PATHS3, S3_DS_BUCKET_MAINTENANCE, S3_FILENAME_JSON_MAINTENANCE } from "./constants/Constant";
import { fetchFeatureMaintenance } from "./store/actions/dashboardAction";
import {initGA} from "./services/googleAnalytics"
import { useHistory } from 'react-router';
import 'react-quill/dist/quill.snow.css';
import {ThemeProvider as MUIThemeProvider} from '@material-ui/core/styles';
import outerTheme from "./theme/theme";
import { PermissionsProvider } from "./contexts/permissionProvider/PermissionsContext";
const store = configureStore();
const URL_FILE_MAINTENANCE = `${PATHS3}${S3_DS_BUCKET_MAINTENANCE}/${S3_FILENAME_JSON_MAINTENANCE}`;

const App = ({ Component, pageProps, userAgent, query }) => {
  const streamMaintenanceTime = 60 * 1000;
  const deviceType = useDeviceType(userAgent);
  const lang = localStorage.getItem('lang');
  const { isMaintenanceMode, setMaintenanceMode } = useMaintenanceMode(); //use provide maintanace option
  const admin = localStorage.getItem("admin");

  const [showNotification, setShowNotification] = useState(false);
  const [mounted, setMounted] = useState(false); //state to control useEffect
  const [notification, setNotification] = useState({ id: '', type: '', order_id: '', title: '', body: '', link: '' });

	if (!localStorage.getItem('firebaseToken') && !navigator?.userAgent?.match(/iPhone|iPad|iPod|Macintosh|FBAN|FBAV|Telegram|Instagram|MicroMessenger/i)
  ) {
    GetToken();
  }

	if (!navigator?.userAgent?.match(/iPhone|iPad|iPod|Macintosh|FBAN|FBAV|Telegram|Instagram|MicroMessenger/i)) {
    onMessageListener().then((payload) => {
      console.log(payload)
      setShowNotification(true);
      setNotification({
        id: payload?.data?.notification_id,
        type: payload?.data?.type,
        order_id: payload?.data?.order_id,
        title: payload.notification.title,
        body: payload.notification.body,
        link: payload?.fcmOptions?.link,
      });
      console.log("Listen for notification(s)...", payload);
    }).catch(err => console.log('failed: ', err));
  }

  useEffect(() => {
    localStorage.removeItem("mode");
    localStorage.removeItem("sub_cat_id");
    localStorage.removeItem("subcatname");
    localStorage.removeItem("cat_id");
    localStorage.removeItem("reordered");
    localStorage.removeItem("isfilter");
  },[])

  const fetchMaintenance = async(URL_FILE_MAINTENANCE, setMaintenanceMode) => {
      try {
          await fetchFeatureMaintenance({
            URL_FILE_MAINTENANCE: URL_FILE_MAINTENANCE,
            setMaintenanceMode: setMaintenanceMode,
            setMounted: setMounted
          });
      } catch (error) {
          setMaintenanceMode(false)
          window.checkMaintenanceCondition(false);
          localStorage.setItem("maintenanceMode", false);
          setMounted(true);
          console.log("err", error);
      }
  }

  useEffect(() => {
    if(mounted === false){
      fetchMaintenance(URL_FILE_MAINTENANCE, setMaintenanceMode);
    }
    if(!admin){
      const intervalId = setInterval(() => {
        fetchMaintenance(URL_FILE_MAINTENANCE, setMaintenanceMode);
      }, streamMaintenanceTime);

      // Clean up the interval when the component unmounts
      return () => clearInterval(intervalId);
    }
  }, [mounted])

  useEffect(() => {
    initGA();
  },[]);

	// Scroll to top on route change (unless anchor link)
	useEffect(() => {
		const unlisten = history.listen((location) => {
			// SEO: Don't scroll to top if there's an anchor/hash (e.g., #section)
			// This preserves anchor link functionality
			if (!location.hash) {
				window.scrollTo(0, 0);
			}
		});
		return () => {
			unlisten();
		};
	}, []);

  return (
    <>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
	        <MUIThemeProvider theme={outerTheme}>
		        <PermissionsProvider>
            <CartProvider>
              <FavoritesProvider>
                <SearchProvider query={query}>
                  <I18nProvider locale={lang}>
                    <HeaderProvider>
                      <AppProvider>
                        <AuthProvider>
                          <StoreLogoProvider>
                            <Router history={history}>
                              <AppLayout deviceType={deviceType} showNotification = {showNotification} {...pageProps} isMaintenanceMode={isMaintenanceMode}>
                                  <Routes {...pageProps} />
                                  <NotificationToast 
                                  showNotification={showNotification}
                                  setShowNotification={setShowNotification}
                                  notification={notification}/>
                              </AppLayout>
                              <GlobalStyle />
                            </Router>
                          </StoreLogoProvider>
                        </AuthProvider>
                      </AppProvider>
                    </HeaderProvider>
                  </I18nProvider>
                </SearchProvider>
              </FavoritesProvider>
            </CartProvider>
          </PermissionsProvider>
	        </MUIThemeProvider>
        </ThemeProvider>
      </Provider>
    </>
  );
};
App.getInitialProps = async (appContext) => {
  const appProps = await App.getInitialProps(appContext);
  const { req, query } = appContext.ctx;
  const userAgent = req ? req.headers["user-agent"] : navigator.userAgent;
  return { ...appProps, userAgent, query };
};
export default App;
